/**
 * OHD-side organization ids. Stable across MLD environments — the same
 * value identifies the same OHD org locally, on staging, and on prod.
 */
export const GOODHUE_OHD_ORG_ID = 959;

/**
 * Read `features.ohd_organization_id` regardless of whether the API
 * returned it as a number or a numeric string. Returns `undefined` if
 * the value is missing or not parseable.
 */
export function readOhdOrgId(features: {ohd_organization_id?: number | string | null} | undefined): number | undefined {
    const raw = features?.ohd_organization_id;
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
    if (typeof raw === 'string' && /^\d+$/.test(raw)) return Number(raw);
    return undefined;
}
